module.exports = __webpack_public_path__ + "static/47-fbd8cd06850d092f36ddcdcfc6622556.jpg";